import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
    fetchFailure,
    fetchRequest,
    fetchSuccess
} from "../reducer/TestReducer";

function* fetchTestData(){
    try{
    const response = yield call(axios.get,"https://jsonplaceholder.typicode.com/posts")

    const test = response.data;
    yield put(fetchSuccess(test));
    } catch(error){
        yield put(fetchFailure(error.message))
    }
}

function* TestViewSaga() {
    yield takeLatest(fetchRequest.type, fetchTestData)
}

export default [TestViewSaga()]